import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/layout.tsx\",\"import\":\"Noto_Sans_JP\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-noto-sans-jp\"}],\"variableName\":\"notoSansJP\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ClientTranslationProvider"] */ "/app/src/app/i18n/client/context.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["MaintenanceHandler"] */ "/app/src/components/MaintenanceHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FirebaseServiceProviders"] */ "/app/src/lib/firebase/FirebaseServiceProviders.tsx");
